import { useCallback } from "react";
import { ACN } from "../../core/form/ACN";
import { Text } from "../../core/form/Text";
import { useConditional } from "../../core/hooks/useConditional";
import { DataContext, useDataContext } from "../../core/hooks/useData";
import { useSaveAwareness } from "../../core/hooks/useSaveContext";
import { Modal } from "../../core/ui/Modal";
import { Table } from "../../core/ui/Table";
import { first } from "../../core/utils/array";
import { FormInline, prepareFormDataForSave } from "../../data-entry/FormModal";
import { CustomCol, DateCol, GenericCol } from "../../layout/TableCells";
import { Company, JointHolding, Name } from "../../types";
import { EditTrackedItem } from "./EditTrackedItem";
import { formatData } from "./Format";
import { parseTrackedItems } from "./parseTrackedItem";
import { HistoryModal } from "./HistoryModal";
import { TrackedItemDisplay } from "./TrackedItemDisplay";
import { Addresses } from "./Address";
import { Tab, TabContainer } from "../../core/ui/Tab";
import { CompanyOfficers } from "./CompanyOfficer";
import { CompanyShareholders } from "./CompanyShareholder";
import { RelationshipsTabContent } from "./RelationshipsTabContent";
import { useEntityLookup } from "../../core/hooks/useEntityLookup";
import { EntitySearch } from "../../data-entry/EntityLookup";


export function JointHoldingEdit(props: {
	jh: JointHolding,
}) {

	const { jh } = props;

	if (!jh.representatives) jh.representatives = [];

	const entities = useEntityLookup(
		jh.representatives,
		(item) => {
			return item;
		}
	);

	const names = parseTrackedItems(jh.names);
	const name = first(names.active);
	if (!jh.names) jh.names = [];

	const edit = useConditional(() => {
		return (
			<EditTrackedItem
				title="Edit Joint Holding Name"

				arr={jh.names}
				initialValues={name}

				canHaveOnlyOneActive={true}

				form="entity-company-name-edit"
				formOptions={{
					showEffective: true,
				}}

				onCancel={edit.close}
				onClose={edit.close}
			/>
		)
	});

	const history = useConditional(() => {
		return (
			<HistoryModal
				title="Name History"
				onClose={history.close}
				items={jh.names}
				cols={[
					GenericCol("Name", "name"),
				]}
			/>
		);
	})

	const chooseEntity = useConditional(() => {
		return (
			<ChooseEntity />
		);
	});
	
	return (

		<>
			<TrackedItemDisplay
				title="Name"
				item={name}
				edit={edit}
				history={history}
				className="bold"
			>
				{
					formatData(
						name ? 
						{
							lines: [ { parts: [ name.name ]} ]
						}
						: undefined
					)
				}
			</TrackedItemDisplay>			
			<Table
				cols={[
					CustomCol({
						title: () => "Representative",
						value: (r, c) => {
							if (!entities || !entities.map) return;
	
							const e = entities.map[r];
							return e.title;
						}
					}),
					CustomCol({
						title: () => "Actions",
						value: (r, c) => {
							return (
								<button
									className="error"
									onClick={() => {
										const i = jh.representatives.indexOf(r);
										if (i >= 0) {
											jh.representatives.splice(i, 1);
											
										}
									}}
								>Delete</button>
							)
						}
					}),
					
				]}
				items={jh.representatives}
			/>

			<button
				className="primary"
				onClick={() => {
					chooseEntity.show({});
				}}
			>Add holder</button>

			{chooseEntity.render()}

		</>
	);
}

export function ChooseEntity(props: {

}) {


	return (
		<Modal
			title="Choose Individual"
			size="width-25vw"
		>
			<EntitySearch options={{}} />
		</Modal>
	)

}